import About from "./components/about";
import Header from "./components/header";
import Home from "./components/index";
import VisaPage from "./components/working&skilled visas";
import TemporaryGraduateVisa from "./components/temporary graduate visa";
import ContactPage from "./components/contact";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProfessionalYear from "./components/professional year";
import CourseChange from "./components/course change";
import SkilledId from "./components/skilled independent visa";
import RegionalVisa from "./components/regionalvisa";
import NomVisa from "./components/nominatedvisa";
import Regional from "./components/2regional";
import TempActivity from "./components/TempActivity";
import CanadaVisa from "./components/canada";
import NZVisa from "./components/newzeland";
import UKVisa from "./components/ukvisa";
import USAVisa from "./components/usavisa";
import AusVisa from "./components/australia";
import AAT from "./components/aat";
import Citizenship from "./components/citizenship";
import PartnerVisas from "./components/partner";
import SkillVisas from "./components/skill";
import VisitorVisas from "./components/visitor";
import StudyVisas from "./components/study";
import FamilyVisas from "./components/family";
import RefugeVisas from "./components/refugee";
import OtherVisas from "./components/other";
import BlogPage from "./components/blog";
import RefundPolicy from "./components/refundpolicy";
import TermsAndServices from "./components/terms&services";
import Privacy from "./components/privacy";
// index.js or App.js
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/workingvisa" element={<VisaPage />} />
          <Route path="/temporarygraduate" element={<TemporaryGraduateVisa />} />
          <Route path="/professional" element={<ProfessionalYear />} />
          <Route path="/coursechange" element={<CourseChange />} />
          <Route path="/skilledID" element={<SkilledId />} />
          <Route path="/workregionalvisa" element={<RegionalVisa />} />
          <Route path="/nominatedvisa" element={<NomVisa />} />
          <Route path="/skilledregional" element={<Regional />} />
          <Route path="/tempactivity" element={<TempActivity/>}/>
          <Route path="/canadavisa" element={<CanadaVisa/>}/>
          <Route path="/nzvisa" element={<NZVisa/>}/>
          <Route path="/ukvisa" element={< UKVisa/>}/>
          <Route path="/usavisa" element={<USAVisa/>}/>
          <Route path="/ausvisa" element={<AusVisa/>}/>
          <Route path="/AATappeal" element={<AAT/>}/>
          <Route path="/citizenship" element={<Citizenship/>}/>
          <Route path="/partner" element={<PartnerVisas/>}/>
          <Route path="/skill" element={<SkillVisas/>}/>
          <Route path="/visitorvisa" element={<VisitorVisas/>}/>
          <Route path="/studyvisa" element={<StudyVisas/>}/>
          <Route path="/family-visa" element={<FamilyVisas/>}/>
          <Route path="/refuge-visa" element={<RefugeVisas/>}/>
          <Route path="/other-visa" element={<OtherVisas/>}/>
          <Route path="/blog" element={<BlogPage/>}/>
          <Route path="/refundpolicy" element={<RefundPolicy/>}/>
          <Route path="/terms&services" element={<TermsAndServices/>}/>
          <Route path="/privacypolicy" element={<Privacy/>}/>
          
        </Routes>
      </BrowserRouter>

    </>
  );
}

export default App;
